import { Link } from "react-router-dom";
import { ReactComponent as AccountEmptyIllustration } from "../../../media/account_empty.svg";
import TopNavbarBack from "../../../components/TopNavbarBack";
import Navbar from "../../../components/Navbar";
import GoToTop from "../../../components/GoToTop";
import "../../../styles/Containers.css";

// Same illustrated guest pattern as grocery/calendar - shared by /menu and
// /account since both are purely personal pages with nothing to show an
// anonymous visitor.
function AccountEmptyState({
  title = "این بخش، بخش شخصی توئه",
  caption = "وارد حسابت شو تا اطلاعات و تنظیماتت رو ببینی و مدیریت کنی.",
}) {
  return (
    <div className="paddingButtom80 grey-background">
      <TopNavbarBack
        title=""
        rbuttonIcon={["icon-iconchevron-right"]}
        rbackground={["rectangle1"]}
        lbuttonIcon={["dNone"]}
        lbuttonHref={["null"]}
        lbackground={["null"]}
      />

      <div className="centerd centerAlign paddingTop10">
        <AccountEmptyIllustration
          role="img"
          aria-label="یک کارت پروفایل خالی با یک آواتار"
        />
        <p className="heading-3 grey-1 marginTop5">{title}</p>
        <p className="subject-2 yekan grey-2 marginTop1 marginBottom5 paddingSide10">
          {caption}
        </p>
        <Link to="/login" className="primaryPurple">
          ورود یا ثبت‌نام
        </Link>
      </div>

      <Navbar />
      <GoToTop />
    </div>
  );
}

export default AccountEmptyState;
